/**
 * Heatmap color-scale functions.
 *
 * Each function maps (value, max) -> Tailwind CSS class string.
 * All three use ratio-based thresholds (value/max) so the ramp spans
 * the actual data range, not hard-coded absolute thresholds.
 *
 * Shared by MonthlyHeatmap; tested independently.
 */

export function emeraldBg(value, max) {
  if (max <= 0) return 'bg-emerald-50 text-emerald-700';
  const ratio = value / max;
  if (ratio >= 0.75) return 'bg-emerald-700 text-white';
  if (ratio >= 0.50) return 'bg-emerald-500 text-white';
  if (ratio >= 0.25) return 'bg-emerald-300 text-emerald-900';
  return 'bg-emerald-100 text-emerald-800';
}

export function blueBg(value, max) {
  if (max <= 0) return 'bg-blue-50 text-blue-700 dark:bg-blue-900 dark:text-blue-200';
  const ratio = value / max;
  if (ratio >= 0.75) return 'bg-blue-700 text-white';
  if (ratio >= 0.50) return 'bg-blue-500 text-white';
  if (ratio >= 0.25) return 'bg-blue-200 text-blue-900 dark:bg-blue-300 dark:text-blue-950';
  return 'bg-blue-50 text-blue-700 dark:bg-blue-900 dark:text-blue-200';
}

export function amberBg(value, absMax) {
  if (absMax <= 0) return 'bg-amber-50 text-amber-700 dark:bg-amber-900 dark:text-amber-200';
  if (value < 0) {
    const ratio = Math.abs(value) / absMax;
    if (ratio >= 0.50) return 'bg-red-600 text-white';
    return 'bg-red-200 text-red-900 dark:bg-red-300 dark:text-red-950';
  }
  const ratio = value / absMax;
  if (ratio >= 0.75) return 'bg-amber-600 text-white';
  if (ratio >= 0.50) return 'bg-amber-400 text-amber-950';
  if (ratio >= 0.25) return 'bg-amber-200 text-amber-900 dark:bg-amber-300 dark:text-amber-950';
  return 'bg-amber-50 text-amber-700 dark:bg-amber-900 dark:text-amber-200';
}

export const GRAY_BG = 'bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-500';
